import React from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const OceanFreight = () => {
  return (
    <ServiceTemplate
      title="Ocean Freight"
      subtitle="Sea Cargo Transport"
      description="Cost-effective sea freight solutions for LCL and FCL shipments across major Europe–Africa trade routes."
      whatIsIt="Ocean freight (sea freight) is the transportation of cargo by ship. It's the most cost-effective mode for international shipping, ideal for large volumes and non-urgent cargo. NETEXEC GLOBAL coordinates ocean freight between South Africa and Europe, with routes connecting Durban, Cape Town, and Ngqura to Le Havre, Marseille, and other European ports."
      whoFor="Ocean freight is for businesses moving larger cargo volumes where cost efficiency is more important than speed. It's ideal for bulk shipments, containers (FCL), or consolidated cargo (LCL)."
      whenToUse="Use ocean freight when you have sufficient lead time and want to minimize freight costs. It's the preferred mode for regular imports/exports, large shipments, and cargo where transit time of several weeks is acceptable."
      howWeHelp="NETEXEC GLOBAL coordinates ocean freight from port to port and beyond. We arrange container bookings (LCL or FCL), handle documentation, coordinate customs clearance at origin and destination, and provide shipment tracking throughout the voyage."
      benefits={[
        'Most cost-effective freight option for large shipments',
        'Suitable for LCL (Less than Container Load) and FCL (Full Container Load)',
        'Established routes connecting South African and European ports',
        'Ideal for regular import/export operations',
        'Complete coordination including port clearance and onward delivery'
      ]}
      nextSteps="Contact NETEXEC GLOBAL with your cargo details, volume, and destination port. We'll recommend the best ocean freight solution (LCL or FCL) with transparent pricing and transit times."
      image="https://images.unsplash.com/photo-1768677859674-42c517273db8?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
    />
  );
};

export default OceanFreight;